<template>
  <div>
    <el-dialog v-bind:title="title" :visible="displayed"  width="80%" :show-close="false">
      <el-form label-width="80px">
        <el-button type="primary" style="margin-bottom: 20px" @click="addAttachments">继续添加附件</el-button>
        <!--<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>-->
        <el-col v-for="(item) in uploadfileList" :key="item.index" >
        <el-row :gutter=10 type="flex" justify="center">
          <el-col :span=6>
            <el-form-item label="附件类型" size="small">
              <el-select  placeholder="请选择附件类型" v-model="item.annexType">
                <el-option :label="key" :value="value" v-for="(key, value) in _enumStore.state['上传附件类型']" :key="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span=10>
            <el-form-item label="标题" size="small" >
              <el-input v-bind:value=" item.annexType|fUploadFileType|formatTitle " :ref="'annexName' + item.index"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span=8>
                <el-upload
                  class="upload-demo"
                  action="/api/fileUpload/json"
                  :data="item"
                  :before-upload="beforeFileUpload"
                  :on-success="uploadFileSuccess"
                  :on-error="uploadFileError"
                  :show-file-list="false"
                  >
                  <el-button size="small" type="success" style="margin-left: 10px;" slot="trigger">{{item.actionName}}</el-button>
                  <el-button size="small" type="warning"  @click="removeAnnex(item)">删除</el-button>

                </el-upload>
          </el-col>
        </el-row>
        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="displayed = false" >取 消</el-button>
        <el-button type="primary" @click="saveUploadRecord">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {timeUtil} from '@/assets/js/util.js'

  export default {
  name: 'UploadDialog',
  data () {
    return {
      type: '',
      displayed: false,
      uploadfileList: [
        {
          annexType: '',
          title: '',
          annexAddress: '',
          fileFormat: 'PDF',
          actionName: '选择文件',
          keyword: this.appCode,
          index: 0
        }
      ],
      totalCount: 0
    }
  },

  props: {
    appCode: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  filters: {
    formatTitle (value) {
      if (value) {
        return value + timeUtil.parseTime(new Date(), '{yyyy}{mm}{dd}{hh}{ii}{ss}')
      }
    }
  },
  methods: {
    addAttachments () {
      this.totalCount = this.totalCount + 1
      this.uploadfileList.push({
        annexType: '',
        title: '',
        annexAddress: '',
        displayed: 'true',
        fileFormat: 'PDF',
        keyword: this.appCode,
        actionName: '选择文件',
        index: this.totalCount
      })
    },
    removeAnnex (item) {
      if (this.uploadfileList.length === 1) {
        this.$message.error('必须保留一条记录')
        return
      }
      var index = this.uploadfileList.indexOf(item)
      this.uploadfileList.splice(index, 1)
    },
    beforeFileUpload(file) {
      // 文件限制10M
      let flag = file.size > 10485760;
      if (flag) {
        this.$message.error('上传文件过大');
      }
      return !flag;
    },
    uploadFileSuccess (response, file, fileList) {
      if (response.status === 0) {
        let [ index1, annexAddress ] = response.data.split('_')
        for (let temp of this.uploadfileList) {
          if (temp.index + '' === index1) {
            temp.annexAddress = annexAddress
            temp.actionName = file.name
          }
        }
      } else {
        this.$message.error(response.msg);
      }

    },
    uploadFileError () {
      this.$message.error('上传错误');
    },
    saveUploadRecord () {
      let params = [];
      for (let file of this.uploadfileList) {
        if (!file.annexType) {
          this.$message.error('请选择附件类型')
          return
        }
        if (!file.annexAddress) {
          this.$message.error('请上传 ' + this.$refs['annexName' + file.index][0].value)
          return
        }
        params.push({
          'appCode': this.appCode,
          'annexName': this.$refs['annexName' + file.index][0].value,
          'annexAddress': file.annexAddress,
          'annexType': 28 // TODO 老代码的bug，现有的代码没有修改
        })
      }
      this.$http.post('/api/common/saveAttach', params).then((response) => {
        if (response.data.status === 0) {
          Object.assign(this.$data, this.$options.data.apply(this))
          this.displayed = false
        } else {
          this.$message.error(response.data.msg)
        }
      })
    }
  },
  mounted () {
    this.$on('display', function () {
      Object.assign(this.$data, this.$options.data.apply(this))
      this.displayed = true
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/bdUploadFileDialog.vue